import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { enforcePatientTenant } from "./utils/tenant-guard";

// Drop a stale cross-tenant patient session BEFORE anything reads it (Layout +
// App snapshot localStorage at module load), so an address-bar tenant switch
// (/home/STHIRA → /home/MANOSHANTI) starts logged out for the new clinic.
enforcePatientTenant();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
